import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

export const KPI_ROWS = [
    { key: "chiffre_affaires", label: "Chiffre d'affaires" },
    { key: "ebe", label: "EBE" },
    { key: "tresorerie", label: "Trésorerie" },
    { key: "bfr", label: "BFR" },
];

export function fmtEur(v) {
    if (v == null) return "—";
    const abs = Math.abs(v);
    const s = abs >= 1_000_000 ? `${(v / 1_000_000).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} M€`
        : abs >= 10_000 ? `${Math.round(v / 1000).toLocaleString("fr-FR")} k€`
        : `${Math.round(v).toLocaleString("fr-FR")} €`;
    return s;
}

export async function fetchKpis(dossierId) {
    const { data, error } = await supabase
        .from("kpis_financiers")
        .select("id, annee_fiscale, chiffre_affaires, ebe, tresorerie, bfr, donnees_extraites, created_at")
        .eq("dossier_id", dossierId)
        .order("annee_fiscale");
    if (error) throw error;
    return data ?? [];
}

export async function extraireKpis(dossierId, onStatus) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const base = `${process.env.REACT_APP_BACKEND_URL}/api/ia/dossiers/${dossierId}/kpis/extraire/jobs`;
    const r = await fetch(base, { method: "POST", headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) {
        const body = await safeJson(r);
        throw new Error(body.detail || `Erreur ${r.status}`);
    }
    const { job_id } = await r.json();
    onStatus?.("analyse");
    let result = null;
    for (;;) {
        await new Promise((res) => setTimeout(res, 3000));
        const jr = await fetch(`${base}/${job_id}`, { headers: { Authorization: `Bearer ${token}` } });
        if (!jr.ok) throw new Error((await safeJson(jr)).detail || `Erreur ${jr.status}`);
        const j = await jr.json();
        if (j.stage === "error") throw new Error(j.error || "Extraction KPI en erreur");
        if (j.stage === "done") { result = j; break; }
    }
    if (!result) throw new Error("Connexion interrompue avant la fin de l'extraction.");
    return result;
}
